import React, { useEffect, useState } from "react";
import { Card, Heading, Icon, Spinner, Stack, Toast } from "@shopify/polaris";
import { DesktopMajor } from "@shopify/polaris-icons";
import * as authService from "../../services/authService";

export default function AccountStatistics() {
    const [newAccount, setNewAccount] = useState("");
    const [recentgrowth, setRecentGrowth] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    useEffect(() => {
        setLoading(true);
        authService
            .activeStatics()
            .then((response) => {
                setLoading(false);

                if (response && response.data && response.data.data) {
                    setNewAccount(response.data.data.firstThiry);
                    setRecentGrowth(response.data.data.ratio);
                }
            })
            .catch((error) => {
                setErrorFlag(true);
                console.log(error);
            });
    }, []);

    return (
        <>
            {/* {
			errorFlag && <Toast error content="Server Error"/>
		} */}
            <Card sectioned>
                <div style={{ marginLeft: "15px" }}>
                    <p
                        style={{
                            fontSize: "25px",
                            margin: "10px 0px 35px 0px",
                        }}
                    >
                        New Account Statistics
                    </p>
                    <div
                        style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            margin: "28px 41px 0px 0px",
                        }}
                    >
                        <div style={{ width: "50%" }}>
                            <Stack>
                                <Icon source={DesktopMajor} />
                                <Heading>New Account</Heading>
                            </Stack>
                            <p>New accounts activated in 30 day period</p>
                            <br />
                            {loading ? (
                                <Spinner size="small" color="inkLightest" />
                            ) : (
                                <p className="account-statistics-font">
                                    {newAccount}
                                </p>
                            )}
                        </div>
                        <div style={{ width: "50%" }}>
                            <Stack>
                                <Icon source={DesktopMajor} />
                                <Heading>Recent Growth</Heading>
                            </Stack>
                            <p>
                                Percentage change compared to 30 days previous
                            </p>
                            <br />
                            {loading ? (
                                <Spinner size="small" color="inkLightest" />
                            ) : (
                                <p className="account-statistics-font">
                                    {recentgrowth ? recentgrowth : 0}%
                                </p>
                            )}
                        </div>
                    </div>
                </div>{" "}
            </Card>
        </>
    );
}
